import { IComponentColumn } from "src/app/core/parts/components/components.interfaces";
import { actionMenu, ColumnType, GridHeaderData } from "src/app/shared/shared.interface";

export const bomHeaders: GridHeaderData[] = [
  
    {
      field: 'bomName',
      title: 'Name',
      filterable: true,
      hidden:false,
      type: ColumnType.LINKWITHNAVIGATIONROUTE,
    },
    {
      field: 'creationDate',
      title: 'Created At',
      filterable: false,
      hidden:false
  
    },
    {
      actions: [
        {
          componentData: {},
          actionType: actionMenu.delete,
        },
      ],
      field: 'Actions',
      title: 'Actions',
    },
  ];

export const bomDetailsGridHeaders: GridHeaderData[] = [
  {
    field: 'matches_count',
    title: 'Matches',
    filterable: false,
    hidden:false
  }
  ,
  {
    field: 'contract_manufacturer_name',
    title: 'CM',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'dt.cm_pn',
    title: 'CM PN',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'dt.customer_pn',
    title: 'CPN',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'uploaded_description',
    title: 'Uploaded Description',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'uploaded_business_unit',
    title: 'Uploaded Business Unit',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'se_lifecycle_status',
    title: 'se_lifecycle_status',
    filterable: true,
    hidden:false
  }
  ,
 {
    field: 'se_rohs',
    title: 'ROHS',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'cm_site',
    title: 'cm_site',
    filterable: true,
    hidden:false

  }
  ,
  {
    field: 'business_unit',
    title: 'Business Unit',
    filterable: true, 
    hidden:false
  }
  ,
  
  {
    field: 'customer_site',
    title: 'Customer Site',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'customer_owner',
    title: 'Customer Owner',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'industry_commodity',
    title: 'Industry Commodity',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'current_supplier',
    title: 'Supplier',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'dt.manufacture',
    title: 'Manufacturer',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'dt.mpn',
    title: 'MPN',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'description',
    title: 'Description',
    filterable: true, 
    hidden:false
  }
  ,

  {
  field: 'uom',
  title: 'U/M',
  filterable: true,
  hidden:false
  }
  ,
  {
    field: 'currency',
    title: 'Currency',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'lead_time',
    title: 'Lead Time',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'moq',
    title: 'Minimum Order Quantity',
    filterable: true,
    hidden:false
 
  }
  ,
  {
    field: 'package_qty',
    title: 'Package Qty',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'package_name',
    title: 'Package Name',
    filterable: true,
    hidden:false
  }
 ,
 {
  field: 'quantity_per_part',
  title: 'Quantity Per',
  filterable: true,
  hidden:false
}
,
{
  field: 'stock_on_hand',
  title: 'Stock On Hand',
  filterable: true,
  hidden:false
}
,
{
  field: 'net_demand',
  title: 'Net Demand',
  filterable: true, 
  hidden:false
}
,
{
  field: 'customer_commodity',
  title: 'Customer Commodity',
  filterable: true, 
  hidden:false
}
,
{
  field: 'where_used',
  title: 'Where Used',
  filterable: true,
  hidden:false
}
,
 {
   field: 'project',
   title: 'Project',
   filterable: true,
   hidden:false
 }
,
{
  field: 'se_avg_price',
  title: 'SE AVG Price',
  filterable: true,
  hidden:false,
}
,
{
  field: 'se_us_china_tariff_impact',
  title: 'China Tariff Status',
  filterable: true,
  hidden:false
}
,
  {
    field: 'se_coo',
    title: 'COO',
    filterable: true,
    hidden:false
  }
  ,
  {
    field: 'se_htsusa_code',
    title: 'HTSUSA Code',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_reach',
    title: 'REACH',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_max_lead_time',
    title: 'SE Maximum Lead Time',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_min_lead_time',
    title: 'SE Minimum Lead Time',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_counterfeit_risk',
    title: 'Counterfeit Risk',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_datasheet',
    title: 'Datasheet',
    filterable: true, 
    hidden:false
  }
  ,
  {
    field: 'se_eol',
    title: 'Estimate Years to EOL',
    filterable: true, 
    hidden:false
  } 
  ,
  {
    field: 'se_avg_inventory',
    title: 'Market Availability Inventory',
    filterable: true, 
    hidden:false
  }
]

export function getGridViewHearders(dynamicColumns: IComponentColumn[] = []): any[] {
  return [
    ...dynamicColumns?.map((c: any) => {
       return {
        field: c.colAlias,
        title: c.partsFeatureName,
        filterColName:c.colName,
        filterable: c.filterable,
        sortable: c.sortable,
      };
    }),
 
    
  ];
}